import { useState } from "react";
import "./assets/Crew.scss";

const Crew = (props) => {
    const [crew, setCrew] = useState(props.crew[3]);
    
    const handleCrew = (e) => {
        const child = e.target.parentNode.childNodes;
        for (let i = 0; i < child.length; i++){
            if ("navi-circle active" === child[i].className){
                child[i].classList.remove("active");
            }
        }
        console.log(e.target.className);
        e.target.classList.add("active");
        for (let i = 0; i < child.length; i++){
            if ("navi-circle active" === child[i].className){
                setCrew(props.crew[i]);
            }
        }
    }

    return(

        <div id="crew">

            <section>
                <div>
                    <h3><span>02</span> Meet your crew</h3>

                    <h2><span>{crew.role}</span></h2>
                    <h1>{crew.name}</h1>

                    <p>{crew.bio}</p>

                    <div className="navi">
                        <div onClick={handleCrew} className="navi-circle"></div>
                        <div onClick={handleCrew} className="navi-circle"></div>
                        <div onClick={handleCrew} className="navi-circle"></div>
                        <div onClick={handleCrew} className="navi-circle active"></div>
                    </div>
                </div>

                <div>
                    <img alt="crew" src={require(`${crew.images.png}`)}/>
                </div>
            </section>
        </div>
    );
}

export default Crew;